module.exports = __webpack_public_path__ + "static/media/boek_08.b698e056.png";